//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AttributeOrigin",1,0],[0,"ConnectedPartAttrToggle",1,0],[0,"CsvFileName",1,0],[0,"Output",1,0],[0,"TemplateFileName",1,0],[1,"WeldPoints",0,"SelectNXObjectList",0]],[[["nExportedAttributes"],"GetExportedAttributes",{R_:{exportedAttributes:""}},0,0],[["exportedAttributes"],"SetExportedAttributes",{},1,0],[["nConnectedPartAttributes"],"GetConnectedPartAttributes",{R_:{connectedPartAttributes:""}},0,0],[["connectedPartAttributes"],"SetConnectedPartAttributes",{},1,0],[[],"ReadAttributesFromWelds",{},0,0],[[],"SaveAsDefault",{},0,0],[[],"RestoreDefault",{},0,0],[[],"SaveToFile",{},0,0],[[],"OpenFromFile",{},0,0]],[]];
SPLM.Weld.ExportWeldBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.ExportWeldBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.ExportWeldBuilder.AttributeOriginType = Object.freeze({
    "Object" : "Object", "Df" : "Df"});

SPLM.Weld.ExportWeldBuilder.OutputType = Object.freeze({
    "IntermediateFile" : "IntermediateFile", "InformationWindow" : "InformationWindow"});

export default SPLM;